const development = false;

export const REACT_APP_BASE_URL = development
  ? "http://localhost:4001/api/v2"
 : "https://cfh-be.onrender.com/api/v2";
  //  : "https://codefunhouse.com/api/v2/";
   
  // : "https://apidev-api.codefunhouse.com/api/v2";


  export const REACT_APP_WEB_SOCKET_URL = development
  ? "http://localhost:4001"
   : "https://cfh-be.onrender.com/api/v2";
 // : "https://codefunhouse.com/api/v2/";
  // : "https://apidev-api.codefunhouse.com";